module.exports = "<a routerLink=\"/home\">\r\n    <img src=\"assets/images/header/logo-header.png\"/>\r\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/logo/logo.component.html
// module id = 771
// module chunks = 1